// extracted by mini-css-extract-plugin
module.exports = {"loading":"Item_loading__3XRff"};